<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="活动id" prop="activityId">
              <el-input
                v-model="searchForm.activityId"
                clearable
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动名称" prop="activityName">
              <el-input
                v-model="searchForm.activityName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户名称" prop="userName">
              <el-input
                v-model="searchForm.userName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="中奖类型" prop="rewardMechanismList">
              <el-select 
                multiple
                collapse-tags
                v-model="searchForm.rewardMechanismList" 
                clearable 
                @change="onSearch"
              >
                <el-option v-for="item in rewardMechanism"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="statusList">
              <el-select 
                multiple
                collapse-tags
                v-model="searchForm.statusList" 
                clearable 
                @change="onSearch"
              >
                <el-option v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="中奖时间" prop="updatedTime">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportList">导出</el-button>
          <el-button type="primary" size="small" @click="importList">导入</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="activityId" label="活动id" align="center" width="90" ></el-table-column>
          <el-table-column prop="activityName" label="活动名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="contactsName" label="用户名称" align="center" width="140" ></el-table-column>
          <el-table-column prop="createdTime" label="中奖时间" align="center" width="160" ></el-table-column>
          <el-table-column prop="rewardMechanism" label="中奖类型" align="center" width="120"></el-table-column>
          <el-table-column prop="awardCondition" label="获奖条件"  align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="prizeName" label="奖品名称" align="center" width="150"></el-table-column>
          <el-table-column prop="couponContent" label="奖品内容" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="statusString" label="状态" align="center"  width="120"></el-table-column>
          <el-table-column prop="exchangeStoreName" label="核销门店" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="storeName" label="分享门店名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="h5UserName" label="分享人" align="center" width="140"></el-table-column>
          <el-table-column prop="cusName" label="经销商名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="statusExcel" label="操作" align="center" width="150">
            <template v-slot="scope">
               <el-button
                class="btn"
                v-if="scope.row.status == 3"
                type="text"
                size="small"
                @click="checkAddress(scope.row)"
              >
                邮递地址
              </el-button>
              <el-button
                v-if="scope.row.expressNo"
                class="btn"
                type="text"
                size="small"
                @click="checkOdd(scope.row.expressNo)"
              >
                查看单号
              </el-button>
              
            </template> 
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <mail-address-pop :isMailAddress.sync="isMailAddress" :id="id" />
    <import-dialog :visible.sync="isShowImport" reportName="importWinPrizeExpressNo"/>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import mailAddressPop from './components/mail-address-pop'
import importDialog from '@/views/import-export/import-dialog'
export default {
  name: "redChallenge",
  mixins: [tableMixin],
  components:{
    mailAddressPop,
    importDialog
  },
  data() {
    return {
      searchForm: {
        activityId:'',
        activityName:'',
        userName: "",
        startTime: "",
        endTime: "",
        statusList: '',
        rewardMechanismList: ''
      },
      rewardMechanism: [
        {value: "1",label: "全国排名"},
        {value: "2",label: "区域排名"},
        {value: "3",label: "阶梯奖励"},
        {value: "4",label: "随机奖励"},
        {value: "5",label: "鼓励奖励"}
      ],
      statusList: [
        {value: "0",label: "未领取"},
        {value: "1",label: "待兑奖"},
        {value: "2",label: "已兑奖"},
        {value: "3",label: "已填写收货信息"},
        {value: "4",label: "未兑奖已过期"},
        {value: "5",label: "未领取已失效"},
        {value: "6",label: "已放弃"},
        {value: "7",label: "已录入运单号"},
        {value: "8",label: "未使用已过期"},
      ],
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isMailAddress: false,
      id: null,
      isShowImport: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .getCountMoney(params) 
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.initDate()
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    checkAddress(row) {
      this.id = row.id
      this.isMailAddress = true
    },
    checkOdd(odd) {
        this.$alert(`邮寄单号：${odd}`, '邮寄单号', {
          confirmButtonText: '确定'
        });
    },
    exportList() {
      let params = {
        ...this.filterParam,
        isDecrypt: true
      };
      this.$api.common.doExport("selectActivityCountMoneyWinPrizeList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
    importList() {
      this.isShowImport = true
    }
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
  .btn  {
    padding: 5px;
  }

</style>
